export default __webpack_public_path__ + "static/media/calendar.c3927202.svg";